import { createRoot } from "react-dom/client";
import App from "../web-sdk-legacy/App";

createRoot(document.getElementById("root")!).render(<App />);
